import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import type { PropsWithChildren } from "react";
import { useTranslation } from "react-i18next";

import { useUser } from "./useUser";

export function PermissionGuard({ children }: PropsWithChildren) {
  const { user, isRolesLoading } = useUser();
  const { t } = useTranslation();

  if (isRolesLoading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", mt: 8 }}>
        <CircularProgress />
      </Box>
    );
  }

  // With implicit Beredare baseline, any authenticated user has access.
  // PermissionGuard only blocks unauthenticated users (user === null).
  const hasAccess = user !== null;

  if (!hasAccess) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "50vh",
          flexDirection: "column",
          gap: 2,
        }}
      >
        <LockOutlinedIcon sx={{ fontSize: 48, color: "text.secondary" }} />
        <Typography variant="h6" sx={{ color: "text.secondary" }}>
          {t("auth.noAccess", "Du har inte behörighet att se ärenden i FAS.")}
        </Typography>
        <Typography variant="body2" sx={{ color: "text.secondary" }}>
          {t("auth.noAccessHelp", "Kontakta din chef för att få tillgång.")}
        </Typography>
      </Box>
    );
  }

  return <>{children}</>;
}
